import { render, staticRenderFns } from "./ExcludePage.vue?vue&type=template&id=0f3c1938&scoped=true&"
import script from "./ExcludePage.vue?vue&type=script&lang=js&"
export * from "./ExcludePage.vue?vue&type=script&lang=js&"
import style0 from "./ExcludePage.vue?vue&type=style&index=0&id=0f3c1938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c1938",
  null
  
)

export default component.exports